// Rotation stimuli are rotated about the ORIGIN, not about their own centre,
// so a probe's raw coordinates drift far outside the reference's bounding box
// and are routinely negative. Each polyline is therefore normalised against
// its OWN bounding box and drawn in its own panel. A shared transform across
// both figures reproduces exactly the bug this exists to prevent.
export function normalisePolyline(points, { size = 100, padding = 10 } = {}) {
  if (!Array.isArray(points) || points.length === 0) return [];

  const xs = points.map(([x]) => x);
  const ys = points.map(([, y]) => y);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  const width = maxX - minX;
  const height = maxY - minY;
  const box = size - padding * 2;

  const scale =
    width === 0 && height === 0 ? 0 : box / Math.max(width, height);

  const offsetX = (size - width * scale) / 2;
  const offsetY = (size - height * scale) / 2;

  return points.map(([x, y]) => [
    (x - minX) * scale + offsetX,
    (y - minY) * scale + offsetY,
  ]);
}
